import assetPath from '@nrdy-marketing-engine/components/src/asset-path';
import Head from 'next/head';

export default function HotmathHead() {
  return (
    <Head>
      <link
        href={assetPath('/vt-hotmath/images/basics/favicons/varsity-tutors/apple-touch-icon.png')}
        rel="apple-touch-icon"
      />
      <meta content="#ffffff" name="theme-color" />
      <meta content="dark" name="nsp-theme" />
    </Head>
  );
}
